import React from 'react';
import PropTypes from 'prop-types';
import StringToComponent from '../../../../lib/stringToComponent';
import DetailsHeader from '../../components/DetailsHeader';
import fireBatchedImpressions from '../../lib/BatchImpressions';
import { cloneDeep, isEmpty } from 'lodash';
import { clientLogger } from '../../../../lib/logger';

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.setLayout();
    const locationValue = this.props.location.pathname.split('/');
    this.locationCategory = locationValue[locationValue.length - 2];
  }

  // this is an over-engineered way of giving each details photo section component a unique id
  // so that we can assign them unique/ numbered 1, 2, 3 ... fpti clicks
  componentDidMount() {
    const detailsPhotoSections =
      document.querySelectorAll('[id*="details-options"]') || [];
    detailsPhotoSections.forEach((component, index) => {
      component.id = `details-options-${index + 1}`;
    });

    const { app: { csrf = '' } = {} } = this.props;
    const links = [];
    this.layout.forEach(({ content = {} }) => {
      links.push(content.PSImpressionUrl);
    });
    fireBatchedImpressions(links, csrf);
  }

  fptiImpressionHandler = tool => {
    if (isEmpty(tool) || !tool.appFPTI) return;
    const { fptiImpression } = this.props;

    fptiImpression({
      pageLink: tool.appFPTI
    });
  };

  setLayout() {
    const location = this.props.location.pathname.split('/').pop();
    // Get the current tool name using the location from above
    // Use that tool name to pull out the layout array
    // Use the layout array to by iterating them and the details content
    // Pass only relevant content per component]
    const { flatPSData = {} } = this.props;
    if (isEmpty(flatPSData)) return;
    const { tools = {}, layouts = [] } = flatPSData;
    const { appKey } =
      Object.values(tools).find(objTool => location === objTool.location) || '';
    let { layout } = appKey
      ? layouts.find(objLayout => objLayout.appKey === appKey)
      : '';
    //Layout found
    if (layout && layout.length) {
      layout = layout.split(',');
      let componentsContent = flatPSData.details
        ? cloneDeep(flatPSData.details)
        : [];
      this.layout = layout
        .map(s => {
          let finalContent;
          // Get the content related to the particular tool
          if (componentsContent[s]) {
            componentsContent[s] = componentsContent[s].filter(
              o => o.toolKey === appKey
            );
            // Sort by order for tools that have the order prop
            finalContent = componentsContent[s]
              .sort((a, b) => a.order - b.order)
              .shift();
          }

          if (!finalContent) {
            this.handleErrorFPTI(`For ${location} : ${s} content is missing`);
          }
          return {
            Component: StringToComponent[s],
            content: finalContent
          };
        })
        .filter(i => i.Component && i.content);
    } else {
      // No Layout found default to header
      const {
        detailsContent: { DetailsHeader: detailsHeaderContent = [] } = {}
      } = this.props;
      // if no layout default to just the header component
      this.layout = [
        {
          Component: DetailsHeader,
          content: detailsHeaderContent.find(o => o.toolKey === appKey)
        }
      ];
    }

    if (this.layout.length < 1 || !this.layout[0]?.content) {
      this.handleErrorFPTI(`${location} Details Layout or content is missing`);
      clientLogger.error(
        `${location} Details layout or content is missing`,
        JSON.stringify({
          country: this.props.app?.legalCountry,
          locale: this.props.app?.context?.locale?.locale,
          loggedIn: this.props.app?.fptiData?.lgin
        })
      );
    }
  }
  handleErrorFPTI = errorMessage => {
    const { fptiImpression } = this.props;
    if (typeof window === 'undefined') return;
    const feedback = window.feedback || {};

    fptiImpression({
      ...feedback,
      erpg: errorMessage,
      eccd: 'code'
    });
  };

  handleClickFPTI = detailFPTI => {
    const { fptiClick } = this.props;
    fptiClick({ fptiLink: detailFPTI });
  };

  render() {
    // Used for generating default alt tags for all images in child components
    const toolName = this.props.tools[this.layout[0]?.content?.toolKey]?.name;

    return (
      <div id="appcenter-details">
        {this.layout.map(({ Component, content }, index) => (
          <Component
            key={`appcenter-component-item-${index}`}
            componentContent={content}
            handleClickFPTI={this.handleClickFPTI}
            toolName={toolName}
            {...this.props}
          />
        ))}
      </div>
    );
  }
}

Details.displayName = 'details';

Details.propTypes = {
  categories: PropTypes.array,
  layoutForStorybook: PropTypes.string,
  location: PropTypes.object,
  detailsContent: PropTypes.object,
  fptiClick: PropTypes.func,
  app: PropTypes.object,
  flatPSData: PropTypes.object,
  fptiImpression: PropTypes.func,
  tools: PropTypes.object
};

export default Details;
